import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        packages: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('packages', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        list: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('loans', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            return new Promise((resolve, reject) => {
                axios.get(`societies/${id}`)
                    .then(response => {
                        // Save the response data to localStorage
                        localStorage.setItem('societyData', JSON.stringify(response.data));
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        }
        ,
        create: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('societies', params)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        update: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`societies/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`societies/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

    }
}